import { render, staticRenderFns } from "./Mediated.vue?vue&type=template&id=31641179"
import script from "./Mediated.vue?vue&type=script&lang=js"
export * from "./Mediated.vue?vue&type=script&lang=js"
import style0 from "./Mediated.vue?vue&type=style&index=0&id=31641179&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports